/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import AudioButtons from '../../components/audio-buttons/AudioButtons';
import styles from './styles';

const aac = require('../../assets/codecs/codec.aac');
// const alac = require('../../assets/codecs/codec.alac');
// const alac = require('../../assets/codecs/codec.m4a');
const flac = require('../../assets/codecs/codec.flac');
const mp3 = require('../../assets/codecs/codec.mp3');
const ogg = require('../../assets/codecs/codec.ogg');
const wav = require('../../assets/codecs/codec.wav');
// const wma = require('../../assets/codecs/codec.wma');

class MusicServices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      aacResource: new Audio(aac),
      // alacResource: new Audio(alac),
      flacResource: new Audio(flac),
      mp3Resource: new Audio(mp3),
      oggResource: new Audio(ogg),
      wavResource: new Audio(wav),
      // wmaResource: new Audio(wma),
    };
  }

  render() {
    const {
      classes: { container },
    } = this.props;
    const {
      aacResource,
      // alacResource,
      flacResource,
      mp3Resource,
      oggResource,
      wavResource,
      // wmaResource,
    } = this.state;

    return (
      <React.Fragment>
        <div className={container}>
          <AudioButtons type="AAC" audio={aacResource} />
          {/* <AudioButtons
            type="ALAC"
            audio={alacResource}
          /> */}
          <AudioButtons type="FLAC" audio={flacResource} />
          <AudioButtons type="MP3" audio={mp3Resource} />
          <AudioButtons type="OGG" audio={oggResource} />
          <AudioButtons type="WAV" audio={wavResource} />
          {/* <AudioButtons
            type="WMA"
            audio={wmaResource}
          /> */}
        </div>
      </React.Fragment>
    );
  }
}

MusicServices.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MusicServices);
